import { render, staticRenderFns } from "./ProfConstructorPanel.vue?vue&type=template&id=3a988018&scoped=true"
import script from "./ProfConstructorPanel.vue?vue&type=script&lang=js"
export * from "./ProfConstructorPanel.vue?vue&type=script&lang=js"
import style0 from "./ProfConstructorPanel.vue?vue&type=style&index=0&id=3a988018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a988018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VExpansionPanelContent,VSimpleCheckbox,VTextField})
